module.exports = __webpack_public_path__ + "static/media/chat07.10bdf035.svg";